import { useState } from "react";
import toast from "react-hot-toast";
import { initiatePayment, verifyPayment } from "../services/payment.service";

const loadRazorpayScript = () => {
    return new Promise((resolve) => {
        if (window.Razorpay) return resolve(true);

        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";

        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);

        document.body.appendChild(script);
    });
};

export const usePayment = (orderResponse) => {
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const startPayment = async () => {
        try {
            if (!selectedPayment) {
                toast.error("Please select payment method");
                return;
            }

            setIsProcessing(true);
            const { provider, secret } = selectedPayment;
            const ref_id = orderResponse?.data?.ref_id;
            const redirect_url = "/api/v1/checkout/payments/initiate";
            const payload = {
                provider,
                secret,
                redirect_url
            };
            //  API CALL (Axios)
            const { data: result } = await initiatePayment(ref_id, payload);

            if (result.success === false) {
                toast.error(result.message);
                return;
            }

            //  Extract properly
            const paymentData = result.data.payments;
            const customer = result.data.customer;

            // =========================
            //  RAZORPAY FLOW
            // =========================
            if (provider === "RAZORPAY") {
                const loaded = await loadRazorpayScript();

                if (!loaded) {
                    toast.error("Razorpay SDK failed to load");
                    return;
                }

                const options = {
                    key: paymentData.key_id, //  from backend
                    amount: paymentData.amount, //  already in paise (NO *100)
                    currency: paymentData.currency,
                    name: "OBSESSIONS",
                    description: "Order Payment",
                    order_id: paymentData.transaction_id,

                    //  important for backend tracing
                    notes: {
                        paymentInitiationId: result.data.paymentInitiationId,
                    },
                    handler: async (response) => {
                        try {
                            const { data: verifyData } = await verifyPayment(response.razorpay_payment_id, response.razorpay_order_id, response.razorpay_signature);
                            if (verifyData.secure_token) {
                                toast.success("Payment Successful");
                                window.location.href = `/payment/callback?secure_token=${verifyData.secure_token}&order_id=${response.razorpay_order_id}&transaction_id=${response.razorpay_payment_id}&signature=${response.razorpay_signature}`;
                                // window.location.href = `/checkout/${verifyData.secure_token}/order-confirmed`;
                            } else {
                                toast.error("Payment verification failed");
                                return false;
                            }
                        } catch (err) {
                            toast.error("Verification error");
                        }
                    },

                    //  correct prefill
                    prefill: {
                        name: customer?.name,
                        email: customer?.email,
                        contact: customer?.mobile,
                    },

                    theme: { color: "#d52326" },

                    modal: {
                        ondismiss: () => {
                            toast.error("Payment cancelled");
                        },
                    },

                    retry: {
                        enabled: true,
                        max_count: 2,
                    },
                };

                const rzp = new window.Razorpay(options);

                rzp.on("payment.failed", (response) => {
                    console.error("Payment Failed:", response);
                    toast.error("Payment Failed");
                });

                rzp.open();
            }

            // =========================
            //  PHONEPE FLOW
            // =========================
            if (provider === "PHONEPE") {
                window.location.href = result.data.payment_link;
            }

        } catch (err) {
            console.error("Payment Error:", err);
            toast.error(err.message || "Payment failed");
        } finally {
            setIsProcessing(false);
        }
    };

    return {
        selectedPayment,
        setSelectedPayment,
        isProcessing,
        startPayment,
    };
};